import SigmaDeviceManager from '@socure-inc/device-risk-sdk';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';
import { SocureDeviceInterface } from 'shared/utils/socureDeviceSessionId/SocureDeviceSessionId.d';

SigmaDeviceManager.initialize({
  sdkKey: getEnvironmentVar('EXPO_SOCURE_KEY'),
});

export class SocureDeviceWeb implements SocureDeviceInterface {
  getSocureDeviceSessionId = async () => {
    let sessionToken;
    try {
      sessionToken = await SigmaDeviceManager.getSessionToken();
    } catch (error) {
      logErrorWithContext(error, {
        featureArea: FeatureArea.FRAUD,
        responsibleTeam: ResponsibleTeam.FRAUD,
        severity: ErrorSeverity.MEDIUM,
      });
    }
    return sessionToken as string;
  };
}

const socureDeviceWeb = new SocureDeviceWeb();

export default socureDeviceWeb;
